import React from "react";

const useAddressQueryInputProps =  <T>() => {
	const queryInputRef = React.useRef<T>(null);
	const [focused, setFocused] = React.useState(false);
	const onFocus = React.useCallback(() => {
		setFocused(true);
	}, []);
	const onBlur = React.useCallback(() => {
		setTimeout(() => {
			setFocused(false);
		}, 500);

	}, []);
	return {
		queryInputRef,
		focused,
		onBlur,
		onFocus,
		setFocused,
	};
};
export default useAddressQueryInputProps